import {createApp} from 'vue';
import { router } from './router';
import App from './App.vue';
import {isBlocked, isLoggedIn, isNotApproved} from './inc/storage';

router.beforeEach((to, from, next) => {

    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    if (nearestWithTitle)
    {
        document.title = nearestWithTitle.meta.title || 'Partner area';
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isLoggedIn.value === false) {
            next({ name: 'Login' })
        } else {

            if (isNotApproved.value && to.name !== 'NotApproved') {
                next({ name: 'NotApproved' })
            }
            else if (isBlocked.value && to.name !== 'Blocked') {
                next({ name: 'Blocked' })
            }
            else
            {
                next() // go to wherever I'm going
            }
        }
    } else {
        next() // does not require auth, make sure to always call next()!
    }
})

createApp(App).use(router).mount('#app')
